





































































import { CertificateInfo, GeoIPInfo } from '@luxtag/papybase';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { find, map } from 'lodash';
import geoip, { IPAPI } from '@/store/modules/geoip';
import GeoIPMixin from '@/mixins/vue/GeoIPMixin';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { geoIP } from '../../../../../plugins/papybase/papybaseInit';
import moment from 'moment';
import theMapStyle from '@/plugins/vue2-google-maps/mapStyles';

@Component({
    filters: {
        time(time: any) {
            return moment(time).format('LL');
        },
    },
})
export default class TrackAndTrace extends Mixins(GeoIPMixin, IsMobileMixin) {
    public pagination = {
        descending: true,
    }
    public clusterMarkers: any[] = [];

    public clusterMarkerHeaders = [
        {
            text: 'Product',
            value: 'address',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Action',
            value: 'action',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Country',
            value: 'country',
            sortable: false,
            align: 'left',
        },
        {
            text: 'Time',
            value: 'createdAt',
            align: 'left',
        },
    ];

    public beforeRouteEnter(to: any, from:any, next: any) {
        next((vm: any) => {
            vm.integrateGeoIPsFromBackEndToLocalStorage().catch((err: any) => {
                console.error(err);
            });
        });
    }

    public onClusterClick(event: any) {
        const mappedMarker = map(event.markers_, marker => JSON.parse(marker.title));
        this.clusterMarkers = mappedMarker;
        // console.log('event', mappedMarker);
    }

    public getProductNameByAddress(address: string) {
        const product: CertificateInfo = this.$store.getters.getProductByAddress(address);
        if (product) {
            if (product.payload) return JSON.parse(product.payload).Model;
        }

        return address.substring(0, 5);
    }

    get geoIPs(): GeoIPInfo[] {
        return this.$store.getters.getGeoIPs;
    }

    // get ipAPIs(): (IPAPI | null)[] {
    //     const mappedLocation = map(this.geoIPs, (ipInfo: GeoIPInfo) => {
    //         const theLocation: IPAPI = this.$store.getters.getIPAPI(ipInfo.ip);
    //         if (theLocation) {
    //             return theLocation;
    //         }
    //         return null;
    //     });
    //     return mappedLocation;
    // }

    get mapStyle() {
        return {
            styles: theMapStyle,
        };
    }

    get noDataText() {
        return 'Please click the cluster inside the map to see the data';
    }

    get center() {
        if (this.geoIPs.length > 0) {
            const firstIp = this.geoIPs[0];
            if (firstIp) {
                return {
                    lat: firstIp.coord_lat,
                    lng: firstIp.coord_lng,
                };
            }
        }

        return {
            lat: 10,
            lng: 10,
        };
    }

    set center(theCenter: any) {
        this.center = theCenter;
    }
}
